<template>
  <div id="chatbot-view">
    <button class="open-button" v-if="showChat" @click="openForm()">
      <span
        ><img src="@/assets/adminlte/images/icon/chat-icon.svg" alt=""
      /></span>
      Chat
    </button>

    <div class="chat-popup mb-5" id="myForm">
      <div :class="expandClass">
        <div class="row form-header">
          <div class="col-md-8">
            <h4>
              LeanBot
            </h4>
          </div>
          <div class="col-md-4 text-end">
            <button type="button" class="close-btn" @click="expandForm()">
              <span
                ><img
                  v-if="expand"
                  class="close-icon"
                  src="@/assets/adminlte/images/icon/minimize.svg"
                  alt=""
                /><img
                  v-else
                  class="close-icon"
                  src="@/assets/adminlte/images/icon/expand.svg"
                  alt=""
                />
              </span>
            </button>
            <button type="button" class="close-btn" @click="closeForm()">
              <span
                ><img
                  class="close-icon"
                  src="@/assets/adminlte/images/icon/close-icon.svg"
                  alt=""
              /></span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="card card-custom ">
            <b-card class="text-left">
              <div class="row col-md-12">
                <div class="row left-side mt-2">
                  <div class="col-md-10">
                    <p class="bg-secondary message">
                      Hi, how can I help you?
                    </p>
                  </div>
                  <div class="col-md-1">
                      <img
                        class="img-avatar"
                        src="@/assets/adminlte/images/lean-icon.png"
                        alt=""
                      />
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-for="chatHistory in chatHistories"
                :key="chatHistory.index"
              >
                <div class="row  right-side">
                  <div class="col-md-2">
                    <!-- <div id="profileImage">C</div> -->
                    <img
                      class="img-avatar"
                      src="@/assets/adminlte/images/profile.png"
                      alt=""
                    />
                  </div>
                  <div class="col-md-10">
                    <p class="bg-primary message">
                      {{ chatHistory.ai }}
                    </p>
                  </div>
                </div>
                <div class="row left-side" v-if="chatHistory.human != ''">
                  <div class="col-md-10">
                    <p class="bg-secondary message">
                      {{ chatHistory.human }}
                    </p>
                  </div>
                  <div class="col-md-1">
                    <img
                      class="img-avatar"
                      src="@/assets/adminlte/images/lean-icon.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div class="row footer">
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              v-model="newMessage"
              v-on:keyup.enter="sentRequestToAi()"
              placeholder="Type.."
            />
          </div>
          <div class="col-md-3">
            <div>
              <!-- <center> -->
              <b-overlay
                :show="loader"
                rounded
                opacity="1"
                spinner-small
                spinner-variant="primary"
                class="b-overlay-custom"
              >
                <button
                  type="button"
                  :disabled="loader"
                  class="btn custom-btn1"
                  @click="sentRequestToAi()"
                >
                  Send
                </button>
              </b-overlay>
              <!-- </center> -->
            </div>
          </div>
          <!-- <textarea
            v-model="newMessage"
            placeholder="Type message.."
            name="msg"
            required
          ></textarea> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorTable from "@/views/admin/errors/ErrorTable";
import request from "@/utils/requestChatbot";

export default {
  name: "ChatBot2",
  components: {
    ErrorTable,
  },
  data() {
    return {
      loader: false,
      INDEX: 0,
      messages: [],
      userMessage: "",
      newMessage: "",
      showChat: true,
      chatHistories: [],
      expand: false,
      expandClass: "form-container",
    };
  },
  methods: {
    openForm() {
      document.getElementById("myForm").style.display = "block";
      this.showChat = false;
    },

    sendMessage() {
      if (this.newMessage.trim() === "") {
        return;
      }
      this.generateMessage(this.newMessage, "self");
      const buttons = [
        {
          name: "Existing User",
          value: "existing",
        },
        {
          name: "New User",
          value: "new",
        },
      ];
      setTimeout(() => {
        this.generateButtonMessage("Choose an option:", buttons);
      }, 1000);
    },

    sentRequestToAi() {
      this.loader = true;
      var message = this.newMessage;
      this.newMessage = "";
      // if (this.loader) {
      //   return;
      // }
      let token = null;
      if (localStorage.getItem("ai_token")) {
        token = localStorage.getItem("ai_token");
      } else {
        const rand_token = Math.random()
          .toString(36)
          .slice(2);
        localStorage.setItem("ai_token", rand_token);
        token = rand_token;
      }
      const updatedChatHistories = this.chatHistories;
      updatedChatHistories.push({ ai: message, human: "" });
      this.updatedChatHistories = updatedChatHistories;
      // setChatHistories(updatedChatHistories);

      let method_type = "";
      let fetch_url =
        "https://lvev6jwaa3xy4nelr4bhofmyvq0ohvqu.lambda-url.us-west-2.on.aws/chat";
      method_type = "post";
      request({
        url: fetch_url,
        method: method_type,
        data: {
          session_id: token,
          message: message,
        },
      })
        .then((data) => {
          this.loader = false;
          this.errors = [];
          if (data) {
            updatedChatHistories[updatedChatHistories.length - 1]["human"] =
              data?.data?.body?.message[0];
            this.chatHistories = updatedChatHistories;
            this.loader = false;
          } else {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire("Error", "Noresponse!", "error");
          }
        })
        .catch(
          function(err) {
            if (err.response.status == 422) {
              this.errors = err.response.data.errors;
            }
            this.loader = false;
          }.bind(this)
        );
    },
    generateMessage(msg, type) {
      this.INDEX++;
      const message = {
        id: this.INDEX,
        type: type,
        text: msg,
        // avatar: type === "self" ? this.selfAvatar : this.userAvatar,
      };
      this.messages.push(message);
      if (type === "self") {
        this.newMessage = "";
      }
      // this.$nextTick(() => {
      //   const chatLogs = this.$el.querySelector(".chat-logs");
      //   chatLogs.scrollTop = chatLogs.scrollHeight;
      // });
    },

    closeForm() {
      this.showChat = true;
      document.getElementById("myForm").style.display = "none";
    },
    expandForm() {
      this.expand = !this.expand;
      if (this.expand) {
        this.expandClass = "form-container-expand";
      } else {
        this.expandClass = "form-container";
      }
    },
  },
};
</script>

<style>
@import "./chatbot.css";
</style>
